import { FormFieldLayout, FormPhoneNumber, TranslationFuncType } from "@itk/mui-components";
import { FormCountryPhonePrefixAutocomplete } from "../countries";
import { FormPhoneProps } from "./form-phone-types";
import { Box, Stack } from "@mui/material";

export const FormPhone = <TObject extends TranslationFuncType>(props: FormPhoneProps<TObject>) => {
  const { phoneNumberFormFieldController, phoneNumberFormFieldState, prefixFormFieldController, prefixFormFieldState, phoneNumberTranslation, prefixTranslation, width = 4 } = props;

  return (
    <FormFieldLayout width={width}>
      <Stack direction="row" gap={1}>
        <Box width={100}>
          {/* Type is being weird here, so instead of wasting more time, I'm sadly forced to use 'any' */}
          {/* eslint-disable-next-line @typescript-eslint/no-explicit-any */}
          <FormCountryPhonePrefixAutocomplete formFieldController={prefixFormFieldController} formFieldState={prefixFormFieldState} width="flex" {...(prefixTranslation as any)} />
        </Box>
        <FormPhoneNumber formFieldController={phoneNumberFormFieldController} formFieldState={phoneNumberFormFieldState} {...phoneNumberTranslation} width="flex" />
      </Stack>
    </FormFieldLayout>
  );
};
